/**
 * Admin Audit Logs Page (PR A9)
 * Renders the full audit logs viewer
 */
import React from 'react';
import AdminAuditLogsPage from './AdminAuditLogsPage';

const AdminAuditLogs = () => {
  return <AdminAuditLogsPage />;
};

export default AdminAuditLogs;
